/**
 * Dispara o download de um arquivo a partir de conteúdo em base64.
 * Usado para entregar a base de mailing (XLSX) retornada pela API sem que
 * o arquivo (com PII) precise ser persistido em storage externo.
 */
export function downloadBase64File(
  base64: string,
  fileName: string,
  mime: string
): void {
  const link = document.createElement('a')
  link.href = `data:${mime};base64,${base64}`
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/** Escapa um campo para CSV: aspas duplas e envolve se houver separador/quebra. */
function escapeCsvField(value: string): string {
  const needsQuotes = /[";\n\r]/.test(value)
  const escaped = value.replace(/"/g, '""')
  return needsQuotes ? `"${escaped}"` : escaped
}

/**
 * Monta e dispara o download de um CSV a partir de linhas (matriz de strings).
 * Usa `;` como separador e BOM UTF-8 para o Excel (pt-BR) abrir com acentos.
 */
export function downloadCsv(rows: string[][], fileName: string): void {
  const content = rows
    .map((row) => row.map(escapeCsvField).join(';'))
    .join('\r\n')
  const blob = new Blob([`﻿${content}`], {
    type: 'text/csv;charset=utf-8;',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
